import { useStripeMeetingConcernsInvoicesQuery } from '../../graphql/react-operations';
import { isNil } from 'lodash-es';
import { LoadingDialog } from '../simple-dialogs/LoadingDialog/LoadingDialog';
import { Invoice } from './Invoice';

interface Props {
  companyId: string;
  meetingId: string;
  onCancel: () => void;
  onPaid: () => void;
}

export const MeetingConcernInvoices = ({ companyId, meetingId, onCancel, onPaid }: Props) => {
  const invoicesQuery = useStripeMeetingConcernsInvoicesQuery({ variables: { companyId, meetingId } });
  if (!isNil(invoicesQuery.error)) {
    // TODO: Handle error
    return null;
  }
  if (invoicesQuery.loading || isNil(invoicesQuery.data)) {
    return <LoadingDialog />;
  }

  const invoices = invoicesQuery.data?.stripeMeetingConcernsInvoices;
  const unpaidInvoices = invoices.filter(i => ['draft', 'open', 'uncollectible'].includes(i.status!));

  const handleOnPaid = async () => {
    // refetch to see if there are more unpaid.
    await invoicesQuery.refetch();
  };

  if (unpaidInvoices.length > 0) {
    // @ts-expect-error TS2532
    return <Invoice invoiceId={unpaidInvoices[0].id} onPaid={() => handleOnPaid()} {...{ companyId, onCancel }} />;
  }
  onPaid();
  return null;
};
